<template>
  <div v-if="selectedFields != null && selectedFields.length > 0">
    <v-form ref="form" lazy-validation>
      <div
        v-if="
          institution.departmentTypes.includes(0)
            ? (selectedFields.length == 7 && category == 0) ||
              (selectedFields.length == 9 && category == 1)
            : (selectedFields.length == 8 && category == 0) ||
              (selectedFields.length == 10 && category == 1)
        "
        class="text-center py-8"
      >
        <strong>{{ $t('Nenhum campo distinto selecionado') }}</strong>
      </div>

      <div v-else>
        <div class="distinct-list pb-3">
          <div class="list my-2" v-for="(order, i) in orders" :key="i">
            <strong class="mr-2" style="min-width: 15px; max-width: 15px">
              {{ i + 1 }}
            </strong>

            <v-checkbox
              v-if="order.serviceOrderType == 5"
              hide-details="auto"
              :label="$t('Proativa')"
              v-model="order.isProactive"
              outlined
              class="mb-4"
            ></v-checkbox>

            <v-autocomplete
              v-model="order.equipmentId"
              append-icon="mdi-chevron-down"
              validate-on-blur
              :rules="[(v) => !!v || 'Selecione o equipamento']"
              v-if="category == 0 && !selectedFields.includes('Identificação')"
              item-text="identification"
              :items="equipments"
              item-value="id"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Identificação')"
              value="Identificação"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.identification }} / {{ item.name }}
                </span>
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="order.unidadeId"
              append-icon="mdi-chevron-down"
              v-if="category == 1 && !selectedFields.includes('Unidade')"
              :rules="[(v) => !!v || 'Selecione a unidade']"
              :items="unidades"
              item-text="name"
              validate-on-blur
              @change="getDepartments(order)"
              item-value="id"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Unidade')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="order.departmentId"
              append-icon="mdi-chevron-down"
              :disabled="!order.unidadeId"
              v-if="category == 1 && !selectedFields.includes('Setor')"
              :rules="[(v) => !!v || 'Selecione o setor']"
              :items="order.departments ? order.departments : departments"
              item-text="name"
              item-value="id"
              validate-on-blur
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Setor')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-text-field
              v-model="order.location"
              v-if="category == 1 && !selectedFields.includes('Localização')"
              outlined
              :rules="[(v) => !!v || 'Digite a localização']"
              style="min-width: 200px"
              class="ma-1 primary-input"
              validate-on-blur
              hide-details="auto"
              :placeholder="$t('Localização')"
              value="Localização"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-text-field
              v-model="order.name"
              v-if="!selectedFields.includes('Nome O.S.')"
              :rules="[(v) => !!v || 'Digite o nome para a O.S.']"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              validate-on-blur
              :placeholder="$t('Nome O.S.')"
              value="Nome O.S."
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-text-field
              v-model="order.requester"
              v-if="!selectedFields.includes('Solicitante')"
              outlined
              :rules="[(v) => !!v || 'Digite o solicitante']"
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              validate-on-blur
              :placeholder="$t('Solicitante')"
              value="Solicitante"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-autocomplete
              v-model="order.serviceOrderType"
              append-icon="mdi-chevron-down"
              style="min-width: 200px"
              :item-text="(item) => $t(item.text)"
              v-if="!selectedFields.includes('Tipo O.S.')"
              :rules="[(v) => v != null || 'Selecione o Tipo da O.S.']"
              outlined
              class="ma-1 primary-input"
              validate-on-blur
              :items="types"
              hide-details="auto"
              :placeholder="$t('Tipo O.S.')"
              value="Solicitante"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="order.responsibleName"
              append-icon="mdi-chevron-down"
              style="min-width: 200px"
              v-if="!selectedFields.includes('Responsável')"
              :rules="[(v) => !!v || 'Selecione o responsável']"
              item-text="name"
              validate-on-blur
              item-value="name"
              :items="users"
              outlined
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Responsável')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-menu
              ref="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              v-if="!selectedFields.includes('Data e hora de solicitação')"
              :rules="[(v) => !!v || 'Digite a data e hora de solicitação']"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  style="min-width: 200px"
                  :rules="[(v) => !!v || 'Selecione a data de solicitação']"
                  :value="formatDate(order.dateTimeRequest)"
                  class="ma-1 primary-input"
                  :placeholder="$t('Data e hora de solicitação')"
                  hide-details="auto"
                  validate-on-blur
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="order.dateTimeRequest"
                scrollable
                locale="pt-Br"
              >
              </v-date-picker>
            </v-menu>

            <v-text-field
              v-if="!selectedFields.includes('Solicitação / Reclamação')"
              :rules="[(v) => !!v || 'Digite a Solicitação / Reclamação']"
              outlined
              v-model="order.request"
              style="min-width: 200px"
              validate-on-blur
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Solicitação / Reclamação')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>

            <v-autocomplete
              v-if="
                !selectedFields.includes('Oficina') &&
                institution.departmentTypes.includes(1)
              "
              v-model="order.workshopId"
              :items="workshopTypes"
              item-text="name"
              item-value="id"
              autocomplete="off"
              :rules="[(v) => v != null || 'Oficina obrigatório']"
              outlined
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Oficina')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
          </div>
        </div>
      </div>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn text @click="$emit('back')">
        {{ $t('Voltar') }}
      </v-btn>
      <v-btn color="primary mr-0" elevation="0" @click="confirm">
        {{ $t('Continue') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'DistinctFieldsStep',

  mounted() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.getWorkshops()

    setTimeout(() => {
      const slider = document.querySelector('.distinct-list')
      let isDown = false
      let startX
      let scrollLeft
      if (slider) {
        slider.addEventListener('mousedown', (e) => {
          isDown = true
          slider.classList.add('active')
          startX = e.pageX - slider.offsetLeft
          scrollLeft = slider.scrollLeft
        })
        slider.addEventListener('mouseleave', () => {
          isDown = false
          slider.classList.remove('active')
        })
        slider.addEventListener('mouseup', () => {
          isDown = false
          slider.classList.remove('active')
        })
        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return
          e.preventDefault()
          const x = e.pageX - slider.offsetLeft
          const walk = (x - startX) * 3 //scroll-fast
          slider.scrollLeft = scrollLeft - walk
        })
      }
    }, 2000)
  },

  props: {
    selectedFields: { type: Array, default: () => [] },
    category: Number,
    users: Array,
    equipments: Array,
    types: Array,
    orders: {
      type: Array,
      default: () => [],
    },
    unidades: Array,
  },

  data() {
    return {
      institution: {},
      apiService: new ApiService(),
      departments: [],
      workshopTypes: [
        { text: 'Carpintaria', value: 0 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
    }
  },

  watch: {
    orders() {
      const haveUnidade = this.orders.filter((x) => !!x.unidadeId)
      if (haveUnidade && haveUnidade.length > 0) {
        this.getDepartments(this.orders[0])
      }
    },
  },

  methods: {
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getDepartments(order) {
      await this.apiService
        .get(`department/list/unidade/${order.unidadeId}`, true, false)
        .then((response) => {
          this.departments = response.content
          order.departments = response.content
          this.departLoading = false
        })
        .catch(() => {
          this.departLoading = false
        })
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : ''
    },

    confirm() {
      if (this.$refs.form.validate()) {
        const institutionId = JSON.parse(localStorage.getItem('institution')).id

        const result = this.orders.map((x) => {
          const equip = this.equipments.find((y) => y.id == x.equipmentId)

          return {
            ...x,
            institutionId,
            unidadeId: x.unidadeId ? x.unidadeId : equip.unidadeId,
          }
        })

        this.$emit('confirm', result)
      }
    },
  },
}
</script>

<style scoped>
.distinct-list {
  overflow-x: scroll;
  margin-bottom: 12px;
}
.distinct-list::-webkit-scrollbar {
  border-radius: 8px;
  height: 7px;
}

.distinct-list::-webkit-scrollbar-thumb {
  border-radius: 8px;
  height: 7px;
  background: #777;
}

.list {
  display: flex;
  align-items: center;
  overflow-x: visible;
  white-space: nowrap;
}
</style>
